/**
 * Gradientes y colores del rediseño del paywall (Figma "Pricing", node 2044:448).
 * Ver ADR-2026-07-28-rediseno-paywall-catalogo-componentes-presentacionales.
 *
 * Van acá porque son degradados con ángulo y stops exactos del diseño: no hay un
 * token del DS que los represente, y repetirlos inline en cada componente los
 * desincroniza. Los colores planos siguen saliendo de `dsColors`.
 */

/** Fondo del sheet de planes: azul profundo → azul marca → azul profundo. */
export const SHEET_GRADIENT =
  'linear-gradient(161.42deg, rgb(0, 33, 152) 0%, rgb(47, 71, 229) 50%, rgb(3, 37, 155) 100%)';

/** Relleno del CTA principal y del badge "Popular" (rosa → magenta). */
export const CTA_GRADIENT =
  'linear-gradient(1.87deg, rgb(255, 11, 98) 9.1%, rgb(250, 74, 231) 90.9%)';

/** Scrim del pie fijo, para que el contenido no choque con el CTA al scrollear. */
export const FOOTER_SCRIM =
  'linear-gradient(to bottom, rgba(3, 37, 155, 0) 0%, rgba(3, 37, 155, 0.85) 38%, rgb(3, 37, 155) 100%)';
